import React, {useState,useEffect,useContext,useRef} from "react";
import { useLocation,useNavigate } from 'react-router-dom'

import CryptoJS from "react-native-crypto-js";

import Auth from '../../userServices/authServices';
import Context from '../context/context';
import Spinner from '../spinner/spinner';
import helpersFunction from "../_helpers/helpersFunction";
import queryString from 'query-string';
const config = require("../_helpers/configServizi");


export default function Signup(props) {
    const  context = useContext(Context)
    let navigate = useNavigate();
	var location = useLocation();
	location = location.pathname.split("/")

    useEffect(() => { 

        //form registrazione
        const query = queryString.parse(window.location.search);
        var encrypted = query.token
        encrypted = encrypted.replace(/\~/g, '/');
        encrypted = encrypted.replace(/\*/g, '+');
        
        if(encrypted){
            var redirect = query.red
     
            if(isBase64(redirect)){

                redirect = window.atob(redirect)
                let bytes  = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_CHIAVE_CRIPTAZIONE)
                let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

                if(decryptedData.email){
                    try{

                        var data = {}
                        const domain = window.location.hostname;
                
                        data.source = decryptedData.source
                        data.country = helpersFunction.getCountry()
                        data.campid = query.campid ? query.campid : null
                        data.city = decryptedData.city ? decryptedData.city : ""
                        data.region = decryptedData.region
                        data.provincia = ""
                        data.email =  decryptedData.email
                        data.password =  decryptedData.password ? decryptedData.password : Math.random().toString(36).slice(2)
                        data.ip = query.ip ? query.ip : null;
                        data.clickid= query.tid ? query.tid : Math.random().toString(36).slice(2)
                        data.fingerprint = localStorage.getItem('fingerprint') ? localStorage.getItem('fingerprint') : null
                        data.fluxId = query.fluxId ? query.fluxId : config.servizi[domain].default_fluxid
                        data.servizio =  window.location.hostname
                        data.ua =  localStorage.getItem('ua') ? localStorage.getItem('ua') : navigator.userAgent
                        data.sono = "uomo"
                        data.cerco = "donna"
                        
                
                        Auth.registerOnExternalEmail(data,context)
                        .then(res => {
                          
                            if(res.token){
                              
                                helpersFunction.setUser(res,context,false,false)
                                context.processoDiNotifica()
					            context.setVerifiedUser(true)
                                helpersFunction.setAnalyticsDimensions(data.clickid,data.source,data.country,data.fluxId,true)
                                window.location.replace(redirect)                  
                            }else{
                               
                                helpersFunction.logToBackend("Externaemail error backend",{err:res,email:decryptedData.email})
                                window.location.replace(redirect)
                            }
                            
                        }).catch((err)=>{
                            console.log(err)
                            helpersFunction.logToBackend("problemi su signup Externaemail",{err:err.message,clickid:localStorage.getItem('trackerId')})
                            navigate('/find')
                            
                        })
                    
                    }catch(err){
                        helpersFunction.logToBackend("problemi su signup Externaemail try catch",{err:err.message,clickid:localStorage.getItem('trackerId')})
                        navigate('/find')
                    }

                }else{
                    helpersFunction.logToBackend("email non ha passato email",{query:window.location.search})
                    console.log("No passata mail")
                    navigate('/find');
                }
            }
        }
	
	},[]);

    
    function isBase64(str) {
        try {
             return btoa(atob(str)) === str ? true : false
        } catch(ex) {
            return false
        }
    }
   


    return (
        
        <div className="all-container">
            <div className="container filters-no-padding" role="main">
                <Spinner/>
            </div>
        </div>
    )
	
}